import { render } from "./SkillTree.vue?vue&type=template&id=39d64d12&scoped=true"
import script from "./SkillTree.vue?vue&type=script&lang=js"
export * from "./SkillTree.vue?vue&type=script&lang=js"

import "./SkillTree.vue?vue&type=style&index=0&id=39d64d12&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d64d12"]])

export default __exports__